export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'accessibility': { id: 'accessibility', page: 'text', getter: () => import(/* webpackChunkName: 'accessibility' */ 'components/bolt/text/text') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'posters', getter: () => import(/* webpackChunkName: "posters" */ 'components/bolt/gallery/gallery'), component: 'gallery' },
	{ id: 'hoja-nueva', getter: () => import(/* webpackChunkName: "hoja-nueva" */ 'components/bolt/text/text'), component: 'text' },
	{ id: 'more-details', getter: () => import(/* webpackChunkName: "more-details" */ 'components/bolt/text/text'), component: 'text' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "boltGallery" */ 'components/bolt/gallery/gallery'), component: 'gallery' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
